module.exports = __webpack_public_path__ + "img/shangpinbense.png";